module.exports = "<span>{{ $ctrl.formatAmount() }}</span>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/shared/base/views/money.html
// module id = 607
// module chunks = 0